import React from "react";
import classes from "./Loader.module.css";
import Spinner from "react-bootstrap/Spinner";

export const Loader = ({ className, height }) => {
  return (
    <>
      <div
        className={`${classes.loaderContainer} ${className && className}`}
        style={{ height: height }}
      >
        <div className={classes.loaderBox}>
          <Spinner animation="grow" className={classes.loader} />
          <Spinner animation="grow" className={classes.loader} />
          <Spinner animation="grow" className={classes.loader} />
        </div>
      </div>
    </>
  );
};
